import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {map} from "rxjs/operators";
import {RequestGeneratedQR, ResponseGeneratedQr} from "../models/qr-form.model";

@Injectable({
  providedIn: 'root'
})
export class QrService {

  constructor(
    private readonly http: HttpClient,
  ) {
  }

  /**
   * @description: Service in charge of bringing the image of the qr in base64
   * @param token obtained from the query params
   * @param request datos del formulario para generar el qr
   */
  getQr(token: string, request: RequestGeneratedQR): Observable<ResponseGeneratedQr> {

    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      })
    };
    return this.http.post<ResponseGeneratedQr>(`${environment.urlglobal_api}/api/v3/bancolombia/qr`,
      request, headers).pipe(map((res) => res));
  }
}
